import React, { Fragment, useState, useEffect } from 'react';
import numeral from 'numeral';

import { useTranslation } from 'react-i18next/hooks';

import Button from '../../../Button/Button';
// import Img from "react-cool-img";
import FilesUploadAction from '../../../FileUploadAction/FilesUploadAction';
import Loader from '../../../Loader/Loader';

import { useStore } from '../../../../hook-store/store';
import { 
  copyDifferentBucketObjects,
  getOriginalFileNameFromKey,
 } from '../../../../util/bucket/bucket-object-util';

import { 
  KURASTORAGE_BACKENDURL,
  KURAIMAGEPHOTO_BACKENDURL,
  KURASTORAGE_URL,
  KURAIMAGEPHOTO_URL,
  SOCKET_GROUP_URL,
} from '../../../../App';

import { marks } from '../../../../images/marks';
import classes from './GroupTalkTextFileKura.module.css';
// import './VideoTextTalk.css'




const GroupKuraFileCopy = (props) => {
  // console.log('VideoTextTalkTextFile.js props', props);
  const {
    // textInputList,
    inputData,
    foundKuraFileData,
    // setShowSepImageHandler,
    // fileUrl,
    // isDownLoading,
    // errorMessage,
    // userId,
    // destUser,
    // noconnectTextDeleteHandler,
    // isLoading,
  } = props;


  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { 
    // selectedKuraFileData,
    // isGroupMember,
    // userGetGroupKuraFileDataList,
  } = store.groupStore;
  const { 
    serviceBucketsDataList,
    serviceTotalSizeGB,
  } = store.serviceBucketsStore;
  const { 
    // bucketName, 
    // topLevels, 
    // totalSizeGB, 
    limitGB,
    // selectedPrefix,
  } = store.bucketObjectStore;

  // console.log('serviceBucketsDataList', serviceBucketsDataList)
  // console.log('limitGB serviceTotalSizeGB', limitGB, serviceTotalSizeGB)

  // const [showFileUpload, setShowFileUpload] = useState(false);
  const [copyDestination, setCopyDestination] = useState('image-photo');
  const [canUpload, setCanUpload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // let canUpload = false;

  // if (limitGB > serviceTotalSizeGB &&
  //     (serviceBucketsDataList && serviceBucketsDataList.length > 0)
  // ) {
  //     canUpload(true);
  // }

  useEffect(() => {
      if (limitGB && serviceTotalSizeGB && limitGB > serviceTotalSizeGB &&
          (serviceBucketsDataList && serviceBucketsDataList.length > 0)
      ) {
        setCanUpload(true);
      }

      //// update service bucket info when not exist
      if (serviceBucketsDataList && serviceBucketsDataList.length === 0) {
        //// set isUploadFailed for get services bucket info (sizes)
        dispatch('SET_ISUPLOADFAILED', true);
      }
  },[serviceBucketsDataList, limitGB, serviceTotalSizeGB]);

  //// set destination to Kura Storege when file is not image
  useEffect(() => {
    if (foundKuraFileData && foundKuraFileData.kuraFileInfo && 
        foundKuraFileData.kuraFileInfo.mimeType &&
        foundKuraFileData.kuraFileInfo.mimeType.split('/')[0] !== 'image'
    ) {
      setCopyDestination('kura-storage');
    }
  },[foundKuraFileData]);

  // console.log('canUpload', canUpload);

  const copyDiffrentBucketObjectHandler = async (
    bucket, 
    key,
    // initialKey,
  ) => {
    try {
      setIsLoading(true);
      dispatch('CLEAR_NOTIFICATION');
      // console.log(bucket, key)
      // return;

      // if (copyDestination === 'kura-storage') {
      //   url = KURASTORAGE_BACKENDURL
      // }

      // if (copyDestination === 'image-photo') {
      //   url = KURAIMAGEPHOTO_BACKENDURL;
      // }

      
      // throw new Error('error-error')

      const  url = SOCKET_GROUP_URL;

      const resData = await copyDifferentBucketObjects(
        url,
        localStorage.getItem('token'),
        bucket,
        [key],
        localStorage.getItem('customerId'),
        'groupTalk',
        inputData.groupRoomId,
        copyDestination,
        // [initialKey],
      );

      setIsLoading(false);

      dispatch('SHOW_NOTIFICATION', {
        status: '',
        title: 'file store success',
        message: '',
      });

      setTimeout(() => {
        //@ts-ignore
        dispatch('CLEAR_NOTIFICATION');
      },1000 * 10);

    } catch(err) {
      console.log(err);

      setIsLoading(false);

      dispatch('SHOW_NOTIFICATION', {
        status: 'error',
        title: `store file failed. ${err.message && err.message}`,
        message: '',
      });

      // setTimeout(() => {
      //   dispatch('CLEAR_NOTIFICATION');
      // },1000 * 10);

      //// set isUploadFailed for get services bucket info (sizes)
      dispatch('SET_ISUPLOADFAILED', true);
      throw err;
    }
  }


  // const kuraFileInfo = inputData.kuraFileInfo;

  // console.log('foundKuraFileData', foundKuraFileData)
  // console.log('isImageFile', isImageFile)
  let groupKuraFileCopyBody;

  if (foundKuraFileData && foundKuraFileData.foundKey && foundKuraFileData.kuraFileInfo) {
    groupKuraFileCopyBody = (
      <div>
          <div>
            {/* <div className={classes.textTalkFileKuraSection}>
              <Button mode="raised" design="" type="submit" 
                  // className='btnBase'
                  // style={{ fontSize: "1.25rem", fontWeight: "bold", border: "1px solid gray" }}
                  // disabled={isLoading}
                  onClick={showFileUploadHandler}
                >
                  Store File {marks.uploadMark}
              </Button>
            </div> */}


              <div>
                <div className={classes.textTalkFileKuraSection}>
                  <div>
                    {t('fileUploadAction08', 'File name')}
                  </div>
                  <div>
                    <strong>
                      {/* {decodeURI(getOriginalFileNameFromKey(inputData.kuraFileInfo.key))} */}
                      {decodeURI(getOriginalFileNameFromKey(foundKuraFileData.foundKey))}
                    </strong>

                    <span>
                      {' '}({numeral(foundKuraFileData.kuraFileInfo.size).format('0.0 b')})
                    </span>
                  </div>
                </div>


                <div>
                  <strong>
                    {t('groupTalk.text61', 'Store file')}
                  </strong>
                </div>
                <div className={classes.textTalkFileKuraSection}>
                  <div>
                    File storage place
                  </div>
                  <div>
                    <span>
                      {copyDestination === 'image-photo' && (
                        <strong>Kura Image Photo</strong>
                      )}
                      {copyDestination === 'kura-storage' && (
                        <strong>Kura Storage</strong>
                      )}
                    </span>
                    {' '}
                    <span>
                      {copyDestination === 'image-photo' && (
                        <span
                          onClick={() => {
                            setCopyDestination('kura-storage')
                          }}
                        >
                          ({t('fileUploadAction16', 'change')}{' '}
                          to Kura Storage)
                        </span>
                      )}
                      {copyDestination === 'kura-storage' && (
                        <span
                          onClick={() => { 
                            setCopyDestination('image-photo')
                          }}
                        >
                          ({t('fileUploadAction16', 'change')}{' '}
                          to Kura Image Photo)
                        </span>
                      )}
                    </span>
                  </div>
                </div>
                
                <div>
                  <Button mode="raised" design="" type="submit" 
                    // className='btnBase'
                    // style={{ fontSize: "1.25rem", fontWeight: "bold", border: "1px solid gray" }}
                    disabled={isLoading || !canUpload}
                    // onClick={showFileUploadHandler}
                    onClick={() => {
                      copyDiffrentBucketObjectHandler(
                        foundKuraFileData.kuraFileInfo.bucket,
                        foundKuraFileData.foundKey,
                        // kuraFileInfo.initialKey,
                      );
                    }}
                  >
                    {t('groupTalk.text61', 'Store file')} {marks.uploadMark}
                </Button>
                </div>
                {isLoading && (
                  <Loader />
                )}
  
              </div>

          </div>
      </div>
    )
  }




  return (
    <Fragment>
      {groupKuraFileCopyBody}
      {/* {showFileUpload && (
        <div>
          <FilesUploadAction 
            filePaths={inputData.filePaths}
            uploadApp={`groupTalk-${inputData.groupRoomId}`}
            kuraFileInfo={inputData.kuraFileInfo}
            groupRoomId={inputData.groupRoomId}
          />
        </div>
      )} */}
    </Fragment>
  );
};

export default GroupKuraFileCopy;